export default "__VITE_ASSET__Dmafti7T__"